import type { RouteLocationNormalized } from "vue-router";

// eslint-disable-next-line no-restricted-exports, unicorn/no-anonymous-default-export
export default (to: Pick<RouteLocationNormalized, "name">) =>
    typeof to.name === "string" &&
    ["slug-entrace", "slug-login", "slug-reset-password-token"].includes(
        to.name,
    );
